import { Bar, BarChart, CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Panel } from "@/components/KpiCard";
import { money } from "@/lib/api";

const COULEURS = ["#047857", "#d97706", "#475569", "#7c3aed"];
const MOIS = ["Janv.", "Févr.", "Mars", "Avr.", "Mai", "Juin", "Juil.", "Août", "Sept.", "Oct.", "Nov.", "Déc."];
const axe = { fontSize: 11, fill: "#64748b" };

const series = (apparts, cle) => MOIS.map((m, i) => Object.fromEntries([["mois", m], ...apparts.map((a) => [a.logement, a.mois[i][cle]])]));

const Graphe = ({ titre, testId, children }) => (
  <Panel title={titre} testId={testId}>
    <div className="h-64 w-full">
      <ResponsiveContainer width="100%" height="100%">{children}</ResponsiveContainer>
    </div>
  </Panel>
);

export const ComparaisonApparts = ({ apparts }) => {
  if (apparts.length < 2) return null;
  return (
    <div className="space-y-6" data-testid="appart-comparaison">
      <Graphe titre="Dépôts reçus par mois" testId="appart-graphe-depots">
        <BarChart data={series(apparts, "depots")} margin={{ top: 5, right: 10, left: 10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
          <XAxis dataKey="mois" tick={axe} />
          <YAxis tick={axe} tickFormatter={(v) => `${Math.round(v / 1000)} k$`} width={48} />
          <Tooltip formatter={(v) => money(v)} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {apparts.map((a, i) => <Bar key={a.logement} dataKey={a.logement} fill={COULEURS[i % COULEURS.length]} radius={[3, 3, 0, 0]} />)}
        </BarChart>
      </Graphe>
      <Graphe titre="Taux d'occupation par mois" testId="appart-graphe-occupation">
        <LineChart data={series(apparts, "taux")} margin={{ top: 5, right: 10, left: 10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
          <XAxis dataKey="mois" tick={axe} />
          <YAxis tick={axe} domain={[0, 100]} tickFormatter={(v) => `${v} %`} width={58} />
          <Tooltip formatter={(v) => `${Number(v).toLocaleString("fr-CA")} %`} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {apparts.map((a, i) => <Line key={a.logement} type="monotone" dataKey={a.logement} stroke={COULEURS[i % COULEURS.length]} strokeWidth={2} dot={{ r: 3 }} />)}
        </LineChart>
      </Graphe>
    </div>
  );
};
